import React, { Component } from "react";

import { HashRouter, Route, Link } from 'react-router-dom';

import { Layout, Menu, Row, Col } from 'antd';

import { inject, observer } from 'mobx-react';


@inject('UserStore')
@observer
export default class NavbarPanel extends Component {

    render() {
        const page = this.props.page
        const { user } = this.props.UserStore
        const userType = _.get(user, "userType", 4)
        return (
            <>
                <div

                    style={{
                        backgroundColor: '#f02',
                    }}>

                    <div className="row no-gutters">
                        <div className="col">
                            <div className="row no-gutters" style={{ height: 40 }}>
                                <div className="col-2" />

                                <div className="col-2">
                                    <Link to="/" className="btn btn-glossred  w-100 rounded-0">
                                        Bahis Yap
                </Link>
                                </div>
                                <div className="col-2">
                                    <Link to="/webtv" className="btn btn-glossred  w-100 rounded-0">
                                        Web Tv
                </Link>
                                </div>
                                <div className="col-2">
                                    <Link to="/program" className="btn btn-glossred  w-100 rounded-0">
                                        Program
            </Link>
                                </div>


                                <div className="col-2">
                                    <Link to="/panel" className="btn btn-glossred  w-100 rounded-0">
                                        Yönetim
                        </Link>
                                </div>

                                <div className="col-2">
                                    <Link to="/panel/result" className="btn btn-glossred  w-100 rounded-0">
                                        Sonuçlar
                                     </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div style={{
                    padding: '10px 50px',
                    fontSize: '1.1em',
                    textAlign: 'left',
                    color: '#FFF',
                    fontWeight: 400,
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    //  flexDirection: 'row'
                }}>
                    <Link
                        className={page == "profile" ? "panelactivelink" : ""}
                        to="/panel/profile" style={{
                            color: '#FFF',
                            float: 'left'
                        }}>
                        Profil
    </Link>





                    {
                        userType != 4
                        &&
                        <>
                            <div style={{ padding: '0 10px', float: 'left' }}>|</div>
                            <Link
                                to="/panel/user"
                                className={page == "user" ? "panelactivelink" : ""}
                                style={{
                                    color: '#FFF',
                                    float: 'left'
                                }}>
                                Kullanıcılar
    </Link>
                            <div style={{ padding: '0 10px', float: 'left' }}>|</div>

                            <Link
                                to="/panel/user/create"
                                className={page == "createUser" ? "panelactivelink" : ""}
                                style={{
                                    color: '#FFF',
                                    float: 'left'
                                }}>
                                Yeni Kullanıcı Ekle
    </Link>



                            <div style={{ padding: '0 10px', float: 'left' }}>|</div>
                            <Link
                                to="/panel/user/limit"
                                className={page == "limit" ? "panelactivelink" : ""}
                                style={{
                                    color: '#FFF',
                                    float: 'left'
                                }}>
                                {userType === 1 ? "Kredi " : "Bakiye "}
                                    Düzenle

    </Link>

                            {
                                userType === 2
                                &&
                                <>
                                    <div style={{ padding: '0 10px', float: 'left' }}>|</div>
                                    <Link
                                        to="/panel/user/credit"
                                        className={page == "credit" ? "panelactivelink" : ""}
                                        style={{
                                            color: '#FFF',
                                            float: 'left'
                                        }}>
                                        Kredi Düzenle
    </Link>
                                </>
                            }


                        </>
                    }



                    <div style={{ padding: '0 10px', float: 'left' }}>|</div>
                    <Link
                        to="/panel/user/coupon"
                        className={page == "coupon" ? "panelactivelink" : ""}
                        style={{
                            color: '#FFF',
                            float: 'left'
                        }}>
                        Kuponlarım
                    </Link>

                    {
                        userType === 2
                        &&
                        <>
                            <div style={{ padding: '0 10px', float: 'left' }}>|</div>
                            <Link
                                to="/panel/system-settings"
                                className={page == "systemSettings" ? "panelactivelink" : ""}
                                style={{
                                    color: '#FFF',
                                    float: 'left'
                                }}>
                                Sistem Ayarları
    </Link>
                        </>
                    }

                    {
                        userType != 4
                        &&
                        <>
                            <div style={{ padding: '0 10px', float: 'left' }}>|</div>
                            <Link
                                to="/panel/report-detail"
                                className={page == "reportDetail" ? "panelactivelink" : ""}
                                style={{
                                    color: '#FFF',
                                    float: 'left'
                                }}>
                                Rapor Detay
    </Link>
                        </>
                    }



                    <div style={{ padding: '0 10px', float: 'left' }}>|</div>

                    <Link to="/panel/report"
                        className={page == "report" ? "panelactivelink" : ""}
                        style={{
                            color: '#FFF',
                            //  float: 'left'
                        }}>
                        Günlük Rapor
</Link>




                </div>
            </>
        )
    }

}
